import React, { Component } from "react";
import { Link } from "react-router-dom";

const navItems = [
  {
    to: "/prevent-collision",
    label: "Система предотвращения столкновений - RIGIDROBOTICS"
  },
  {
    to: "/sober-eye",
    label: "Система мониторинга персонала - SOBEREYE"
  },
  {
    to: "/meglab",
    label:
      "Оптимизация и безопасность подземных горных работ - IMAGINE"
  },
  {
    to: "/aianalytics",
    label:
      "Продвинутая аналитика и искусственный интеллект в горном деле - RIGIDROBOTICS"
  },
  {
    to: "/electrics",
    label: "Изготовление электрооборудования"
  }
];

export default class NavBar extends Component {
  state = { active: false };

  handleClick = () => {
    this.setState(({ active }) => ({ active: !active }));
  };

  closeMenu = () => {
    this.setState({ active: false });
  };

  render() {
    return (
      <header id="header" className="site-header">
        <nav className="app-navbar" aria-label="Main navigation">
          <div className="app-navbar-brand">
            <Link className="app-navbar-logo" to="/" onClick={this.closeMenu}>
              <strong>uVision Safety Solutions</strong>
            </Link>
            <button
              className={`app-navbar-burger ${this.state.active ? "is-active" : ""}`}
              type="button"
              aria-label="Toggle navigation"
              aria-expanded={this.state.active}
              onClick={this.handleClick}
            >
              <span />
              <span />
              <span />
            </button>
          </div>
          <div className={`app-navbar-menu ${this.state.active ? "is-active" : ""}`}>
            <div className="app-navbar-dropdown">
              <button className="app-navbar-link" type="button">
                Решения
              </button>
              <div className="app-navbar-dropdown-menu">
                {navItems.map(item => (
                  <Link key={item.to} to={item.to} onClick={this.closeMenu}>
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>
            <Link className="app-navbar-link" to="/services" onClick={this.closeMenu}>
              Услуги
            </Link>
          </div>
        </nav>
      </header>
    );
  }
}
